"use memo"

import { useCallback, useEffect, useMemo } from 'react'
import NSWAgreementDetailsStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/NSW/NSWAgreementDetailsStageSteps'
import { TaskModalPageProps } from '../TaskModalPageProps'

const NswAgreementDetails = ({
  task,
  toggleTaskStep,
  agreementDetails,
  onAgreementDetailsUpdated,
}: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps])

  useEffect(() => {
    const startStep = taskSteps.find((step) => step.order === 7)
    const endStep = taskSteps.find((step) => step.order === 8)

    if (startStep && startStep.isCompleted !== Boolean(agreementDetails?.startDate)) {
      toggleTaskStep(startStep.order ?? 0, Boolean(agreementDetails?.startDate))
    }

    if (endStep && endStep.isCompleted !== Boolean(agreementDetails?.endDate)) {
      toggleTaskStep(endStep.order ?? 0, Boolean(agreementDetails?.endDate))
    }
  }, [agreementDetails, taskSteps, toggleTaskStep])

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked)
    },
    [toggleTaskStep]
  )

  if (!onAgreementDetailsUpdated) {
    return null
  }

  return (
    <NSWAgreementDetailsStageSteps
      agreementDetails={agreementDetails}
      onAgreementDetailsUpdated={onAgreementDetailsUpdated}
      isOpen={false}
      exceededGap={false}
      tasksStage={taskSteps}
      updateTaskStep={updateTaskStep}
    />
  )
}

export default NswAgreementDetails
